import { OnlineSales } from 'gw-edge-client';
import type { CoverableChangeDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

export const privateHouseAttributesInfoSelector = selector<CoverableDTO>({
    key: 'attributeInfoSelector',
    get: async ({ get }) => {
        const { productName, coverableId } = get(opcInfoAtom);
        const { jobNumber } = get(jobInfoAtom);
        const coverableChangeDTO: CoverableChangeDTO = {
            coverableId,
            productName
        };
        return await OnlineSales.getAttributesForOPC(jobNumber, coverableChangeDTO);
    }
});
